'use client';

import { c as _c } from "react/compiler-runtime";
import { TextPassage } from '@petsmart-ui/sparky';
import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { logSentryEvent } from '@libs/common-next/utils';
import { isTestRun } from './helpers';
import { useGoogleRecaptcha } from './useGoogleRecaptcha';
export function GoogleRecaptchaCheckbox(t0) {
  const $ = _c(17);
  const {
    className,
    id,
    page: t1,
    parent
  } = t0;
  const page = t1 === undefined ? "" : t1;
  const {
    recaptchaErrorCheckbox,
    renderRecaptchaCheckbox,
    useRecaptchaCheckbox
  } = useGoogleRecaptcha();
  let t2;
  if ($[0] !== id || $[1] !== useRecaptchaCheckbox) {
    t2 = !isTestRun() && useRecaptchaCheckbox === id;
    $[0] = id;
    $[1] = useRecaptchaCheckbox;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const shouldRenderCheckbox = t2;
  const isRecaptchaError = shouldRenderCheckbox && recaptchaErrorCheckbox;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(_temp2, t3);
  let t4;
  if ($[4] !== id || $[5] !== renderRecaptchaCheckbox || $[6] !== shouldRenderCheckbox) {
    t4 = () => {
      if (shouldRenderCheckbox) {
        renderRecaptchaCheckbox(id);
      }
    };
    $[4] = id;
    $[5] = renderRecaptchaCheckbox;
    $[6] = shouldRenderCheckbox;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== id || $[9] !== useRecaptchaCheckbox) {
    t5 = [id, useRecaptchaCheckbox];
    $[8] = id;
    $[9] = useRecaptchaCheckbox;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  if (shouldRenderCheckbox) {
    logSentryEvent("Recaptcha checkbox rendered", {
      sentryContext: {
        action: "RECAPTCHA_CHECKBOX_RENDER",
        page
      },
      tags: {
        component: parent,
        page
      }
    });
  }
  let t6;
  if ($[11] !== className || $[12] !== id || $[13] !== isRecaptchaError || $[14] !== recaptchaErrorCheckbox || $[15] !== shouldRenderCheckbox) {
    t6 = shouldRenderCheckbox ? <div className={className} data-testid="recaptcha-checkbox">{isRecaptchaError && <TextPassage className="sparky-u-color-utility-error">{recaptchaErrorCheckbox}</TextPassage>}<div id={id} /></div> : null;
    $[11] = className;
    $[12] = id;
    $[13] = isRecaptchaError;
    $[14] = recaptchaErrorCheckbox;
    $[15] = shouldRenderCheckbox;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp2() {
  const resizeHandler = _temp;
  window.addEventListener("resize", resizeHandler);
  return () => window.removeEventListener("resize", resizeHandler);
}
function _temp() {
  window.dispatchEvent(new WheelEvent("scroll"));
}